/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Fedorov Maxim
 * @version 1.0.1
 * @since 1.0.1
 */

export const LOAD_LIST_INQUIRIES_REQUEST =
    '@@b2b_portal_ui/widgetOrderInquiries/LOAD_LIST_INQUIRIES_REQUEST';
export const LOAD_LIST_INQUIRIES_SUCCESS =
    '@@b2b_portal_ui/widgetOrderInquiries/LOAD_LIST_INQUIRIES_SUCCESS';
export const LOAD_LIST_INQUIRIES_FAIL =
    '@@b2b_portal_ui/widgetOrderInquiries/LOAD_LIST_INQUIRIES_FAIL';

export const LOAD_LIST_ORDERS_REQUEST =
    '@@b2b_portal_ui/widgetOrderInquiries/LOAD_LIST_ORDERS_REQUEST';
export const LOAD_LIST_ORDERS_SUCCESS =
    '@@b2b_portal_ui/widgetOrderInquiries/LOAD_LIST_ORDERS_SUCCESS';
export const LOAD_LIST_ORDERS_FAIL =
    '@@b2b_portal_ui/widgetOrderInquiries/LOAD_LIST_ORDERS_FAIL';
